import './NewsForm.scss';

import React, { useState } from 'react';
import { cn } from '../../../common/utils/bem';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { Button } from '@dataartdev/uikit/Button';
import { Typography } from '@dataartdev/uikit/Typography';
import { Form } from './models';
import FormBuilder from '../../../common/components/Form/FormBuilder';
import { mutationMainAllForm } from '../../../network';
import { Modal } from '@dataartdev/uikit/Modal';
import { cnContentBuilderTemplate } from '../../../common/components/ContentBuilder/templates';

export const cnNewsForm = cn('NewsForm');

interface Props {
  formSubmitButton?: string;
  formTitle?: string;
  form: Form | null | undefined;
  cameFrom: string;
  pageId: number | null;
}

export const NewsForm: React.FC<Props> = ({
  formSubmitButton = 'Download',
  formTitle = '',
  form,
  cameFrom,
  pageId,
}) => {
  const [successForm, setSuccessForm] = useState(false);
  const { text, title, link } = form?.successPopup || {};
  return (
    <div className={cnNewsForm()}>
      {formTitle && (
        <Typography.Title as="h2" size="sm" className={cnNewsForm('Title')}>
          {formTitle}
        </Typography.Title>
      )}

      {form && (
        <FormBuilder
          // formTitle={formTitle}
          form={form}
          dictionariesForm={{}}
          setSuccessForm={setSuccessForm}
          submitText={formSubmitButton}
          cameFrom={cameFrom}
          downloadableLink={link}
          onSubmitForm={async body =>
            await mutationMainAllForm({
              body: {
                ...body,
                pageId,
                cameFrom,
              },
            })
          }
        />
      )}
      {successForm && (
        <Modal
          view="secondary"
          hasOverlay
          onOpen={() => {
            document.body.style.overflow = 'hidden';
          }}
          onClose={() => {
            document.body.style.overflow = 'unset';
          }}
          isOpen={successForm}
          onOverlayClick={(): void => {
            setSuccessForm(false);
            document.body.style.overflow = 'unset';
          }}
          onEsc={(): void => {
            setSuccessForm(false);
            document.body.style.overflow = 'unset';
          }}
          showCloseButton
          inverted
        >
          <div className={cnContentBuilderTemplate('ModalSuccess')}>
            {title && (
              <Typography.Title
                size="lg"
                className={cnContentBuilderTemplate('ModalSuccess-Title')}
              >
                {title}
              </Typography.Title>
            )}
            {text && (
              <Typography.Text
                className={cnContentBuilderTemplate('ModalSuccess-SubTitle')}
              >
                {text}
              </Typography.Text>
            )}
            <Button
              label={form?.successPopup?.link?.title}
              iconRight={IconArrowRight}
              view="secondary"
              className={cnNewsForm('Download')}
              onClick={() =>
                window.open(link?.link, link?.targetBlank ? '_blank' : '_self')
              }
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
